import type {MouseEventHandler, ReactElement} from 'react';
import React from 'react';
import styles from './font-button-item.module.scss';

interface FontButtonItemProps {
  id?: string;
  className?: string;
  imageUrl: string;
  isSelected?: boolean;
  showFilterOverlayWhenSelected?: boolean;
  onClick?: MouseEventHandler;
}

export function FontButtonItem({id = '', className = '', onClick = $.noop, isSelected = false, showFilterOverlayWhenSelected = true, ...props}: FontButtonItemProps): ReactElement<any> {
  return (
    <li
      onClick={onClick}
      id={id}
      className={`${styles.fontButtonContainer} ${className} ${isSelected ? styles.selectedButtonContainer : ''} flex-center hover-transition-all spacing-p-0`}
    >
      <img src={props.imageUrl} alt="" className={isSelected && showFilterOverlayWhenSelected ? styles.selectedFontButtonImage : ''} />
    </li>
  );
}
